import { constants } from '../data/languages';
import { LanguageRedirectUrl } from '../config';

const { domains, fixedDomains } = constants;

export const getLocalizedLocation = (location: Location | null = null, language = 'en') => {
  const alternateLink = typeof document !== 'undefined' && document.querySelector(`link[rel="alternate"][hreflang="${language}"]`);
  const alternateHref = alternateLink && alternateLink.getAttribute('href');
  const protocol = location && location.protocol ? location.protocol : 'https:';
  const hostname = (location && location.hostname) || '';
  const domain = fixedDomains.indexOf(hostname) >= 0 ? hostname : `${language === 'en' ? 'www' : language}.${domains.wixNaked}`;
  const path = location ? `${location.pathname || ''}${location.search || ''}` : '';
  return alternateHref || `${protocol}//${domain}${path}`;
};

interface SetLanguageUrlParams {
  language: string;
  location: Location | null;
  languageRedirectUrl?: LanguageRedirectUrl;
}

export const setLanguageUrl = ({ language, location, languageRedirectUrl }: SetLanguageUrlParams) => {
  const defaultRedirectUrl = getLocalizedLocation(location, language);
  const modifiedRedirectUrl = languageRedirectUrl ? languageRedirectUrl({ language }) : null;
  const redirectToURL = typeof modifiedRedirectUrl === 'string' ? modifiedRedirectUrl : defaultRedirectUrl;
  return `https://${domains.wixUsers}/wix-users/auth/setLanguage?language=${language}&redirectTo=${encodeURIComponent(redirectToURL)}`;
};
